import { render, staticRenderFns } from "./STextDescPreview.vue?vue&type=template&id=b720489a&"
import script from "./STextDescPreview.vue?vue&type=script&lang=js&"
export * from "./STextDescPreview.vue?vue&type=script&lang=js&"
import style0 from "./STextDescPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports